<ng-container *transloco="let t">
  <pxw-modal-dialog
    [title]="t('pricingErrorsDialog.title')"
    [acceptText]="t('pricingErrorsDialog.acceptText')"
    type="alert"
  >
    <pxw-icon icon="alert" />
    <ng-template #modalContent>
      <p>{{ t('pricingErrorsDialog.description') }}</p>
      <table class="pricing-errors">
        <thead>
          <tr>
            <th class="product">{{ t('pricingErrorsDialog.product') }}</th>
            <th class="price">{{ t('pricingErrorsDialog.before') }}</th>
            <th class="price">{{ t('pricingErrorsDialog.after') }}</th>
          </tr>
        </thead>
        <tbody>
          @for (pricingError of pricingErrors(); track pricingError.id) {
            <tr>
              <td class="product">
                @if (pricingError.parentItem) {
                  <span>{{ pricingError.parentItem.name }} - </span>
                }
                <span>{{ pricingError.name }}</span>
              </td>
              <td class="price price-before">
                {{ pricingError.oldPriceDiscount || pricingError.oldPrice | currencyFormat }}
              </td>
              <td class="price">
                {{ pricingError.newPriceDiscount || pricingError.newPrice | currencyFormat }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </ng-template>
  </pxw-modal-dialog>
</ng-container>
